import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getGeneralData, findAllLessons } from 'service/api';

// Constants - action names
export const GET_GENERAL_DATA = 'pv-kultu/general/GET_GENERAL_DATA';
export const GET_GENERAL_DATA_SUCCESS = 'pv-kultu/general/GET_GENERAL_DATA_SUCCESS';
export const GET_GENERAL_DATA_FAILED = 'pv-kultu/general/GET_GENERAL_DATA_FAILED';
export const GET_ALL_LESSONS = 'pv-kultu/general/GET_ALL_LESSONS';
export const ALL_LESSONS_SUCCESS = 'pv-kultu/general/ALL_LESSONS_SUCCESS';

// Initial state
const initialState = {
  loading: false,
  error: undefined,
  examClasses: undefined,
  lessons: undefined,
  lessonStatuses: undefined,
  lessonPauseTypes: undefined,
  drivingLessonTopics: undefined
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_GENERAL_DATA:
      return Object.assign({}, state, {
        loading: true
      });
    case GET_GENERAL_DATA_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        examClasses: action.examClasses,
        lessons: action.lessons,
        lessonStatuses: action.lessonStatuses,
        lessonPauseTypes: action.lessonPauseTypes,
        drivingLessonTopics: action.lessonTopics
      });
    case GET_GENERAL_DATA_FAILED:
      return Object.assign({}, state, {
        loading: false,
        error: action.error
      });
    case  GET_ALL_LESSONS:
      return Object.assign({}, state, {loading: true});
    case ALL_LESSONS_SUCCESS:
      return Object.assign({}, state, {
        lessons: action.lessons,
        loading: false,
      });
    default:
      return state;
  }
}

// Actions
export function getGeneralDataAction() {
  return {type: GET_GENERAL_DATA};
}

export function getGeneralDataSuccess(examClasses, lessons, lessonStatuses, lessonPauseTypes, lessonTopics) {
  return {type: GET_GENERAL_DATA_SUCCESS, examClasses, lessons, lessonStatuses, lessonPauseTypes, lessonTopics};
}

export function getGeneralDataFailed(error) {
  return {type: GET_GENERAL_DATA_FAILED, error};
}

export function getAllLessonsAction() {
  return {type: GET_ALL_LESSONS}
}
export function getAllLessonsSuccess(lessons) {
  return {type:ALL_LESSONS_SUCCESS, lessons:lessons}
}

// Sagas
export function* handleGetGeneralDataSaga() {
  try {
    const options = {
      contentType: 'application/json',
    };
    const response = yield call(getGeneralData, options);
    yield put(getGeneralDataSuccess(response.examClasses, response.lessons, response.lessonStatuses, response.lessonPauseTypes, response.lessonTopics));
  } catch (error) {
    yield put(getGeneralDataFailed(error));
  }
}

export function * getAllLessonsSaga() {
  try {
    const options =  {
      contentType: 'application/json',
      queryParams: {
        'descriptionsOnly' : true
      }
    };
    const response = yield call(findAllLessons, options);
    yield put(getAllLessonsSuccess(response));
  } catch (error) {
    yield put(getGeneralDataFailed(error));
  }
}

function* watchGeneralData() {
  yield takeEvery(GET_GENERAL_DATA, handleGetGeneralDataSaga);
  yield takeEvery(GET_ALL_LESSONS, getAllLessonsSaga);
}

export function* generalDataSagas() {
  yield all([
    watchGeneralData(),
  ]);
}


// WEBPACK FOOTER //
// ./src/ducks/general.js